module.exports = __webpack_public_path__ + "img/icon25.6ac50e76.png";